/* Ancestral Brotherhood — training page effects.
 *
 * Sound is SYNTHESIZED with WebAudio, not downloaded. No mp3, no preload, no
 * network cost, so it cannot affect page loading. It is off until the visitor
 * turns it on, and the choice persists.
 *
 * Motion never gates visibility: every element is visible without this file
 * running, and the reveal class only adds transitions.
 */
(function () {
  'use strict';

  /* Two sections load this file so the masthead works on its own. Running the
     listeners twice would double every sound, so the second run stops here. */
  if (window.__abTrainFx) return;
  window.__abTrainFx = true;

  /* ---------------------------------------------------------- quote ----- */
  /* Drawn per visit from the theme asset. No network call and no key: the well
     is generated in the coach view and shipped as a file. */
  (function () {
    var fig = document.querySelector('.ab-trh__quote');
    if (!fig || !window.AB_QUOTES || !window.AB_QUOTES.length) return;
    var q = window.AB_QUOTES[Math.floor(Math.random() * window.AB_QUOTES.length)];
    var t = fig.querySelector('.ab-trh__quote-t');
    var c = fig.querySelector('.ab-trh__quote-s');
    if (t) t.textContent = q.t;
    if (c) c.textContent = q.s || 'Ancestral Brotherhood';
    fig.hidden = false;
  })();

  /* Save-Data means the visitor asked not to be sent heavy media. A looping
     background video is exactly that. */
  (function () {
    var c = navigator.connection;
    if (c && c.saveData) {
      var v = document.querySelector('.ab-trh__video');
      if (v) { v.pause(); v.remove(); }
    }
  })();

  var reduceAll = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------- lazy background video
     preload="none" and no src until the visitor scrolls near: the page loads
     no video bytes it is not about to show. Sources live in data-src. */
  (function () {
    var vids = document.querySelectorAll('video[data-lazy]');
    if (!vids.length) return;
    if (reduceAll) { vids.forEach ? vids.forEach(function (v) { v.remove(); }) : null; return; }
    var arm = function (v) {
      if (v.__armed) return;
      v.__armed = true;
      Array.prototype.forEach.call(v.querySelectorAll('source[data-src]'), function (so) {
        so.src = so.getAttribute('data-src');
      });
      v.load();
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    };
    if (!('IntersectionObserver' in window)) { Array.prototype.forEach.call(vids, arm); return; }
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { arm(e.target); var p = e.target.play(); if (p && p.catch) p.catch(function(){}); }
        else if (e.target.__armed) { e.target.pause(); }
      });
    }, { rootMargin: '300px 0px' });
    Array.prototype.forEach.call(vids, function (v) { vio.observe(v); });
  })();

  /* -------------------------------------------------- kinetic masthead ----
     Split the title into word spans so each rises on its own beat. Text stays
     intact for screen readers via aria-label. */
  (function () {
    if (reduceAll) return;
    var t = document.querySelector('.ab-trh__title');
    if (!t || t.querySelector('span')) return;
    var words = (t.textContent || '').trim().split(/\s+/);
    if (words.length < 2 || words.length > 12) return;
    t.setAttribute('aria-label', words.join(' '));
    t.innerHTML = words.map(function (w, i) {
      return '<span class="ab-trh__w" aria-hidden="true" style="--wi:' + i + '">' + w + '</span>';
    }).join(' ');
  })();

  var root = document.querySelector('.ab-tr');
  if (!root) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------- install (PWA) --
     Shopify serves theme assets from the CDN origin, and a manifest fetched
     cross-origin resolves start_url against ITSELF -- the install would point
     at cdn.shopify.com. The fix: build the manifest at runtime and inject it
     as a data: URI, which resolves start_url against THIS page. Icons use
     absolute CDN URLs, which is allowed. */
  (function () {
    var cfg = window.AB_PWA;
    if (!cfg || !cfg.i192) return;

    var manifest = {
      name: 'Ancestral Training Hall',
      short_name: 'Ancestral',
      description: 'Sixteen programs. Every set logged. Marks set, and marks broken.',
      start_url: '/pages/training?source=pwa',
      scope: '/',
      display: 'standalone',
      background_color: '#0d0c0b',
      theme_color: '#0d0c0b',
      icons: [
        { src: cfg.i192, sizes: '192x192', type: 'image/png', purpose: 'any' },
        { src: cfg.i512, sizes: '512x512', type: 'image/png', purpose: 'any' },
        { src: cfg.mask, sizes: '512x512', type: 'image/png', purpose: 'maskable' }
      ]
    };
    var link = document.createElement('link');
    link.rel = 'manifest';
    link.href = 'data:application/manifest+json,' + encodeURIComponent(JSON.stringify(manifest));
    document.head.appendChild(link);

    var meta = document.createElement('meta');
    meta.name = 'apple-mobile-web-app-capable'; meta.content = 'yes';
    document.head.appendChild(meta);
    var bar = document.createElement('meta');
    bar.name = 'apple-mobile-web-app-status-bar-style'; bar.content = 'black-translucent';
    document.head.appendChild(bar);
    var ttl = document.createElement('meta');
    ttl.name = 'apple-mobile-web-app-title'; ttl.content = 'Ancestral';
    document.head.appendChild(ttl);
    if (cfg.i180) {
      var apple = document.createElement('link');
      apple.rel = 'apple-touch-icon'; apple.href = cfg.i180;
      document.head.appendChild(apple);
    }

    var btn = document.querySelector('[data-ab-install]');
    if (!btn) return;

    var deferred = null;
    var isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
    var standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    if (standalone) { btn.remove(); return; }

    window.addEventListener('beforeinstallprompt', function (e) {
      e.preventDefault();
      deferred = e;
      btn.hidden = false;
    });
    /* iOS never fires beforeinstallprompt; show the button and teach the path. */
    if (isIOS) btn.hidden = false;

    btn.addEventListener('click', function () {
      if (deferred) {
        deferred.prompt();
        deferred.userChoice.then(function () { deferred = null; });
      } else if (isIOS) {
        showIosCoach();
      }
    });
    window.addEventListener('appinstalled', function () { btn.remove(); });

    /* iOS install coach: Safari never exposes an install prompt, so the next
       best thing is pointing at the one that exists. On iPhone Safari the
       Share button sits bottom-center, so the card anchors above it with a
       caret aimed straight at it. iPad Safari puts Share top-right; the card
       flips up there. Chrome/Firefox on iOS get the card without a caret,
       since their Share lives in different chrome. */
    function showIosCoach() {
      if (document.querySelector('.ab-coach')) return;
      var ua = navigator.userAgent;
      var isIpad = /ipad/i.test(ua) || (navigator.maxTouchPoints > 1 && /macintosh/i.test(ua));
      var isChrome = /crios/i.test(ua);
      var isFirefox = /fxios/i.test(ua);
      var isEdge = /edgios/i.test(ua);
      var otherBrowser = isChrome || isFirefox || isEdge;
      var share = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true" style="width:17px;height:17px;vertical-align:-3px"><path d="M12 15V4m0 0L8 8m4-4l4 4M5 12v7a1.5 1.5 0 001.5 1.5h11A1.5 1.5 0 0019 19v-7"/></svg>';
      var plus = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true" style="width:17px;height:17px;vertical-align:-3px"><rect x="4" y="4" width="16" height="16" rx="3"/><path d="M12 9v6M9 12h6"/></svg>';
      var el = document.createElement('div');
      el.className = 'ab-coach' + (isIpad ? ' ab-coach--top' : '') + (otherBrowser ? ' ab-coach--plain' : '');
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-label', 'How to install the app');
      /* Every iOS browser can install to the home screen — they just bury it
         at different depths. Chrome and Edge hide it behind "View more" in
         the Share sheet; Firefox puts it in its own menu; Safari lists it
         directly. Telling anyone to "switch to Safari" is wrong advice. */
      var steps;
      if (isChrome || isEdge) {
        steps = 'Tap ' + share + ' <b>Share</b>, then <b>View more</b>, then <b>Add to Home Screen</b> ' + plus;
      } else if (isFirefox) {
        steps = 'Open the <b>&hellip;</b> menu, then <b>Share</b>, then <b>Add to Home Screen</b> ' + plus;
      } else {
        steps = 'Tap ' + share + ' <b>Share</b> ' + (isIpad ? 'in the top corner' : 'below') +
                ', then choose <b>Add to Home Screen</b> ' + plus;
      }
      el.innerHTML =
        '<button type="button" class="ab-coach__x" aria-label="Dismiss">&times;</button>' +
        '<p class="ab-coach__t">Install the Training Hall</p>' +
        '<p class="ab-coach__s">' + steps + '</p>';
      document.body.appendChild(el);
      var kill = function () { el.remove(); document.removeEventListener('pointerdown', outside, true); };
      var outside = function (e) { if (!el.contains(e.target)) kill(); };
      el.querySelector('.ab-coach__x').addEventListener('click', kill);
      setTimeout(function () { document.addEventListener('pointerdown', outside, true); }, 100);
      setTimeout(kill, 16000);
    }
  })();

  /* ---------------------------------------------------------- arrival ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    io.observe(root);
  } else {
    root.classList.add('is-in');
  }

  /* Stagger index for the rise effect, set from the DOM so markup stays clean. */
  Array.prototype.forEach.call(root.querySelectorAll('[data-rise]'), function (el, i) {
    el.style.setProperty('--i', String(i));
  });

  /* ------------------------------------------------------------ sound ---- */
  var KEY = 'ab-train-sound';
  var on = false;
  try { on = localStorage.getItem(KEY) === '1'; } catch (e) { /* private mode */ }

  var ctx = null;
  function audio() {
    if (ctx) return ctx;
    var C = window.AudioContext || window.webkitAudioContext;
    if (!C) return null;
    ctx = new C();
    return ctx;
  }

  /* An anvil strike: a struck body with a fast metallic partial over it. Two
     oscillators and a noise burst -- cheaper than any file and it never 404s. */
  function strike(freq, dur, gain) {
    if (!on) return;
    var a = audio();
    if (!a) return;
    /* Browsers start a context suspended unless it was created inside a
       gesture. resume() is async, so schedule against the time AFTER it
       resolves rather than a currentTime that is still frozen at 0. */
    if (a.state === 'suspended') {
      a.resume().then(function () { ring_(a, freq, dur, gain); }).catch(function () {});
      return;
    }
    ring_(a, freq, dur, gain);
  }

  function ring_(a, freq, dur, gain) {

    var t = a.currentTime;
    var out = a.createGain();
    out.gain.setValueAtTime(gain, t);
    out.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    out.connect(a.destination);

    var body = a.createOscillator();
    body.type = 'triangle';
    body.frequency.setValueAtTime(freq, t);
    body.frequency.exponentialRampToValueAtTime(freq * 0.55, t + dur);
    body.connect(out);
    body.start(t); body.stop(t + dur);

    var ring = a.createOscillator();
    ring.type = 'square';
    ring.frequency.setValueAtTime(freq * 3.1, t);
    var rg = a.createGain();
    rg.gain.setValueAtTime(gain * 0.12, t);
    rg.gain.exponentialRampToValueAtTime(0.0001, t + dur * 0.4);
    ring.connect(rg); rg.connect(a.destination);
    ring.start(t); ring.stop(t + dur * 0.4);
  }

  var lastHover = 0;
  function scrape() {
    var now = Date.now();
    if (now - lastHover < 120) return;   /* a card grid would otherwise machine-gun */
    lastHover = now;
    strike(150, 0.10, 0.045);
  }

  /* Delegated: the app re-renders its whole subtree on every state change, so
     per-node listeners would be lost on the first click. */
  root.addEventListener('pointerenter', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.prog, .btn, .tab, .ab-tr__chip, .ab-tr__submit')) scrape();
  }, true);

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.prog, .btn-primary, .ab-tr__submit')) {
      strike(96, 0.42, 0.16);          /* full anvil for a real commitment */
    } else if (t.closest('.btn, .tab')) {
      strike(150, 0.16, 0.075);        /* lighter tap for ordinary controls */
    }
  }, true);

  /* ------------------------------------------------------------ toggle --- */
  var btn = root.querySelector('.ab-tr__sound');
  if (btn) {
    var paint = function () {
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.querySelector('.ab-tr__sound-label').textContent = on ? 'Sound on' : 'Sound off';
    };
    paint();
    btn.addEventListener('click', function () {
      on = !on;
      try { localStorage.setItem(KEY, on ? '1' : '0'); } catch (e) {}
      paint();
      if (!on) return;
      /* Created inside the click so the browser lets it start, and resumed
         explicitly for the case where it already existed and was suspended. */
      var a = audio();
      if (a && a.state === 'suspended') a.resume().catch(function () {});
      strike(120, 0.34, 0.15);
      setTimeout(function () { strike(190, 0.22, 0.10); }, 150);
    });
  }
})();
